import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const customAddressSchema = (t: TFunction) =>
  Yup.object().shape({
    country: Yup.string().required(t('Country is required')),
    deliveryType: Yup.string().required(t('Delivery type is required')),
    city: Yup.string().required(t('City is required')),
    code: Yup.string().required(t('Postal code is required')),
    street: Yup.string().required(t('Street is required')),
    contact: Yup.string()
      .optional()
      .max(50, t('Field accept maximum 50 characters'))
      .nullable(),
    email: Yup.string().optional().email().nullable(),
    phone: Yup.string()
      .optional()
      .nullable()
      .max(50, t('Field accept maximum 50 characters')),
  });
